import { useEffect } from "react"; // Added useEffect
import { BrowserRouter } from "react-router-dom";
import Router from "./Router";
import { ThemeProvider } from "@emotion/react";
import { appTheme } from "./Components/CstmTheme/Theme";
import { CssBaseline } from "@mui/material";
import AlertPopUp from "Components/AlertPopUp";
import OverlayLoader from "Components/OverlayLoader";

const App = () => {
  useEffect(() => {
    // 1. Disable Right-Click
    const handleContextMenu = (e) => e.preventDefault();

    // 2. Disable Keyboard Shortcuts
    const handleKeyDown = (e) => {
      if (
        e.key === "F12" ||
        (e.ctrlKey && e.shiftKey && (e.key === "I" || e.key === "J" || e.key === "C")) ||
        (e.ctrlKey && e.key === "u")
      ) {
        e.preventDefault();
      }
    };

    // 3. Optional: Detect if DevTools is opened via window resizing
    const handleResize = () => {
      const threshold = 160;
      if (
        window.outerWidth - window.innerWidth > threshold ||
        window.outerHeight - window.innerHeight > threshold
      ) {
        console.log("DevTools detected!");
        // You could redirect or clear state here
      }
    };

    window.addEventListener("contextmenu", handleContextMenu);
    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("contextmenu", handleContextMenu);
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <ThemeProvider theme={appTheme}>
      <CssBaseline />
      <OverlayLoader />
      <AlertPopUp />
      <BrowserRouter>
        <Router />
      </BrowserRouter>
    </ThemeProvider>
  );
};

export default App;
